import { getTokens } from 'core/classes/helpers/StorageHelper'
import settings from 'src/config/settings'

/** The user's stored cockpit, as `spJBPPlanningCockpitStoreSetRecalc` reports it. */
export interface ICockpitRecalcStatus {
  /** 1 while the stored cockpit waits to be recalculated; back to 0 once it is. */
  ToRecalc: number
  /** When the recalculation was last requested. */
  SetToRecalcDate: string | null
}

type CockpitRecalcResponse = {
  status?: 'success' | 'fail' | 'error'
  data?: ICockpitRecalcStatus | null
  message?: string
}

/* Only the partner cockpit recalculates for now, so the top partners' store is left alone. */
const postCockpitRecalc = async (
  action: 'recalc' | 'recalcStatus',
  fYear: number
): Promise<ICockpitRecalcStatus | null> => {
  const [accessToken] = getTokens()

  const response = await fetch(
    `${settings.httpsServices.partner360}/api/v0/planningCockpit/${action}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      body: JSON.stringify({ fYear, isTopPartners: false }),
    }
  )

  const result = (await response.json().catch(() => ({}))) as CockpitRecalcResponse

  if (!response.ok || result.status !== 'success') {
    throw new Error(result.message || `Cockpit ${action} failed with status ${response.status}`)
  }

  return result.data ?? null
}

/** Marks the user's stored cockpit for recalculation; `null` when the user has none yet. */
export const requestCockpitRecalc = (fYear: number) => postCockpitRecalc('recalc', fYear)

/** The recalculation status of the user's stored cockpit, without changing it. */
export const fetchCockpitRecalcStatus = (fYear: number) => postCockpitRecalc('recalcStatus', fYear)
